export const exportToCSV = (data: any, period: string) => {
  const timestamp = new Date().toISOString().split('T')[0];
  const filename = `estatisticas-${period}-${timestamp}.csv`;

  let csv = 'Métrica,Data,Valor\n';

  // Usuários
  data.users.forEach((item: any) => {
    csv += `Novos Usuários,${item.date},${item.count}\n`;
  });

  // Conversas
  data.conversations.forEach((item: any) => {
    csv += `Conversas,${item.date},${item.count}\n`;
  });

  // Documentos
  data.documents.forEach((item: any) => {
    csv += `Documentos,${item.date},${item.count}\n`;
  });

  // Casos
  if (data.casos) {
    data.casos.forEach((item: any) => {
      csv += `Casos,${item.date},${item.count}\n`;
    });
  }

  // Tokens
  data.tokens.forEach((item: any) => {
    csv += `Tokens Input,${item.date},${item.input}\n`;
    csv += `Tokens Output,${item.date},${item.output}\n`;
  });

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};
